module.exports = __webpack_public_path__ + "media/img/u262-d157db3a4c0f8689c5cf86ce37c031d6.png";